export function validateHostNameFormat(hostname: string): boolean {
    const topLevelDomain = hostname.substring(0, hostname.indexOf('.'))
    const containsOnlyLetters = (str: string) => str.match(/^[A-Za-z]+$/)

    return (
        topLevelDomain.length !== 0 &&
        !!containsOnlyLetters(topLevelDomain) &&
        topLevelDomain + '.charge.space' === hostname
    )
}
